import {
    GET_ADMINS,
    CREATE_ADMIN,
    UPDATE_ADMIN,
    DELETE_ADMIN,
    TOGGLE_ADMIN_DISABLED,
    OPEN_ADMIN_DIALOG,
    CLOSE_ADMIN_DIALOG,
} from "./types";

const initialState = {
    admins: [],
    dialog: false,
    dialogData: null,
};

const adminManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ADMINS:
            return {
                ...state,
                admins: action.payload,
            };
        case CREATE_ADMIN:
            const data = [...state.admins];
            data.unshift(action.payload);
            return {
                ...state,
                admins: data,
            };
        case UPDATE_ADMIN:
            return {
                ...state,
                admins: state.admins.map((admin) => {
                    if (admin._id === action.payload.id) return action.payload.data;
                    else return admin;
                }),
            };
        case DELETE_ADMIN:
            return {
                ...state,
                admins: state.admins.filter(
                    (admin) => admin._id !== action.payload
                ),
            };
        case TOGGLE_ADMIN_DISABLED:
            return {
                ...state,
                admins: state.admins.map((admin) => {
                    if (admin._id === action.payload.id) return action.payload.data;
                    else return admin;
                }),
            };
        case OPEN_ADMIN_DIALOG:
            return {
                ...state,
                dialog: true,
                dialogData: action.payload || null,
            };
        case CLOSE_ADMIN_DIALOG:
            return {
                ...state,
                dialog: false,
                dialogData: null,
            };

        default:
            return state;
    }
};

export default adminManagementReducer;
